import getMessageCountRequest from "./requests/message-count-request";
import setUserRequest from "./requests/set-user-request";
import getMessagesRequest from "./requests/get-messages-request";

const supportRepository = {
    messageCount: getMessageCountRequest,
    setUser: setUserRequest,
    getMessages: getMessagesRequest,
};

export default supportRepository;
